import Content from "common/components/Content/Content";
export default Content;
